export default __webpack_public_path__ + "static/media/send_people_staff.9f60f3ad.svg";